// extracted by mini-css-extract-plugin
export var input = "logreg-module--input--72c7e";
export var label = "logreg-module--label--d2db4";
export var logreg = "logreg-module--logreg--f483d";
export var squarecheck = "logreg-module--squarecheck--0b983";
export var subtitle = "logreg-module--subtitle--c2490";
export var title = "logreg-module--title--df3f7";
export var wrap = "logreg-module--wrap--40253";